import { CountryState } from '@core/models/country-list-response';
import { createAction, props } from '@ngrx/store';

export const LoadStatesProps = createAction('[States] Load States Props');
export const LoadStatesProperties = createAction(
  '[State] Load States Success',
  props<{ statesProperties: CountryState[] }>()
);
